import React, {useState} from 'react';
import axios from 'axios';
import {getHostIP} from '../../networking/Hosts';
import {APPOINTMENT_CITIES, getAppointmentSites} from '../../data/appointmentSites';
import styles from './AppointmentRegistration.module.css';

export default function AppointmentRegistration({project}) {
    const isRsv = project === 'RSV';
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [city, setCity] = useState('');
    const [siteId, setSiteId] = useState('');
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState('');
    const sites = getAppointmentSites(project, city);
    const site = sites.find(s => s.id === siteId);
    async function submit(e) {
        e.preventDefault();
        if (busy || done) return;
        if (!name.trim() || !city || (sites.length > 0 && !site)) {
            setError('请填写姓名、选择城市和接种点'); return;
        }
        if ((isRsv || phone) && !/^1\d{10}$/.test(phone)) {
            setError('请输入有效的11位手机号'); return;
        }
        setBusy(true); setError('');
        try {
            const result = await axios.post(`${getHostIP()}/api/appointmentRegistrations`, {
                vaccine_type: project, name: name.trim(), phone: phone || null, city,
                site_id: sites.length ? siteId : null,
            }, {withCredentials: true});
            if (result.status !== 201 || result.data?.status !== 'registered') throw new Error('save_failed');
            setDone(true);
        } catch (e) {setError(e.response?.data?.error || '登记未保存成功，请稍后重试');}
        finally {setBusy(false);}
    }
    return <main className={styles.page}><form className={styles.form} onSubmit={submit}>
        <header className={styles.header}><span className={styles.tag}>{isRsv ? '宝宝 RSV 预防服务' : '本季流感预防服务'}</span><h1>预约接种登记</h1>
        <p>{isRsv ? '建议在医生评估后，让宝宝接受RSV预防性单抗注射。' : '建议接种本季流感疫苗，请填写预约登记信息。'}</p></header>
        <section className={styles.section}><h2><span>01</span> 联系信息</h2><div className={styles.fields}><div className={styles.field}>
        <label htmlFor="appointment-name">{isRsv ? '家长姓名（必填）' : '接种者姓名（必填）'}</label>
        <input id="appointment-name" className={styles.inputText} autoComplete="name" placeholder={isRsv ? "请输入家长姓名" : "请输入接种者姓名"} maxLength={50} value={name} onChange={e => setName(e.target.value)} disabled={busy || done}/>
        </div><div className={styles.field}>
        <label htmlFor="appointment-phone">手机号（{isRsv ? '必填' : '选填'}）</label>
        <input id="appointment-phone" className={styles.inputText} type="tel" inputMode="numeric" autoComplete="tel-national" placeholder={isRsv ? "请输入11位手机号" : "可选填，方便工作人员联系"} maxLength={11} value={phone} onChange={e => setPhone(e.target.value)} disabled={busy || done}/>
        </div></div></section>
        <section className={styles.section}><h2><span>02</span> 接种地点</h2><div className={styles.fields}><div className={styles.field}>
        <label htmlFor="appointment-city">城市</label>
        <select id="appointment-city" className={styles.select} value={city} onChange={e => {setCity(e.target.value); setSiteId('');}} disabled={busy || done}>
            <option value="">请选择城市</option>{APPOINTMENT_CITIES.map(c => <option key={c}>{c}</option>)}
        </select>
        </div><div className={styles.field}>
        <label htmlFor="appointment-site">接种点</label>
        <select id="appointment-site" className={styles.select} value={siteId} onChange={e => setSiteId(e.target.value)} disabled={busy || done || !sites.length}>
            <option value="">{city && !sites.length ? '接种点待确认' : '请选择接种点'}</option>
            {sites.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
        </select>
        </div></div>
        {site && <section className={styles.siteCard} aria-label="接种点信息"><p>地址：{site.address || '待确认，请电话咨询'}</p><p>电话：{site.phone ? <a href={`tel:${site.phone}`}>{site.phone}</a> : '待确认，请向接种点咨询'}</p><p>开放时间：{site.hours || '待确认，请电话咨询'}</p></section>}
        {city && !sites.length && <p className={styles.notice}>接种点待确认，可先提交城市和预约需求登记。</p>}
        {!isRsv && city === '嘉兴市' && <p className={styles.guide}>浙江线上预约指引：浙里办搜索“浙里接种”，选择或绑定接种者 → 选择“疫苗预约”“流感疫苗”、种类及接种点 → 阅读详情、选择时间、立即预约。</p>}
        </section>
        <p className={styles.privacy}>本登记用于接种需求统计及预约联系，信息仅供项目工作人员使用并保密。提交后，工作人员可按您填写的手机号联系您。登记不代表预约成功。</p>
        {error && <p className={styles.error} role="alert">{error}</p>}
        {done && <p className={styles.success} role="status">登记已提交，预约安排以接种点确认为准</p>}
        <button className={styles.button} disabled={busy || done}>提交登记</button>
    </form></main>;
}
